<template>
    <div ref="reportReasonDistributionBarChart" style="min-height: 500px;"></div>
</template>

<script>
    /* Imports */
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";

    export default {
        data () {
            return {
                chart : null,
                dummyData : [{
                    "reason": "Oli Bocor",
                    "mpx1": this.randomInt(100, 1000),
                    "mpx2": this.randomInt(100, 1000),
                    "mpx3": this.randomInt(100, 1000),
                    "spx1": this.randomInt(100, 1000),
                    "spx2": this.randomInt(100, 1000),
                }, {
                    "reason": "Label Rusak",
                    "mpx1": this.randomInt(100, 1000),
                    "mpx2": this.randomInt(100, 1000),
                    "mpx3": this.randomInt(100, 1000),
                    "spx1": this.randomInt(100, 1000),
                    "spx2": this.randomInt(100, 1000),
                }, {
                    "reason": "QR Code Tidak Valid",
                    "mpx1": this.randomInt(100, 1000),
                    "mpx2": this.randomInt(100, 1000),
                    "mpx3": this.randomInt(100, 1000),
                    "spx1": this.randomInt(100, 1000),
                    "spx2": this.randomInt(100, 1000),
                }, {
                    "reason": "Oli Expired",
                    "mpx1": this.randomInt(100, 1000),
                    "mpx2": this.randomInt(100, 1000),
                    "mpx3": this.randomInt(100, 1000),
                    "spx1": this.randomInt(100, 1000),
                    "spx2": this.randomInt(100, 1000),
                }, {
                    "reason": "Tutup Botol Rusak",
                    "mpx1": this.randomInt(100, 1000),
                    "mpx2": this.randomInt(100, 1000),
                    "mpx3": this.randomInt(100, 1000),
                    "spx1": this.randomInt(100, 1000),
                    "spx2": this.randomInt(100, 1000),
                }]
            }
        },
        props : ['data'],
        mounted () {
            this.createChart();
            this.getData();
        },
        watch : {
            'data' : {
                deep : true,
                handler : 'getData'
            }
        },
        methods : {
            getData () {
                let length = this.chart.data.length;
                // let data = [{'reason' : 'No Data',"mpx1" : 0, "mpx2" : 0, "mpx3" : 0, "spx1" : 0, "spx2" : 0}];
                let data = [{'reason' : 'No Data',"mpx1" : 0, "mpx2" : 0, "mpx3" : 0, "spx1" : 0, "spx2" : 0, "unknown" : 0}];

                //Check for null data
                if (this.data != null && this.data.length > 0) {
                    data = JSON.parse(JSON.stringify(this.data)).map((x)=>{ return {
                        reason:x.reason?x.reason:'Unknown',
                        mpx1:x.mpx1?x.mpx1:0,
                        mpx2:x.mpx2?x.mpx2:0,
                        mpx3:x.mpx3?x.mpx3:0,
                        spx1:x.spx1?x.spx1:0,
                        spx2:x.spx2?x.spx2:0,
                        unknown:x.unknown?x.unknown:0
                    }});
                }

                this.chart.addData(data, length);
            },
            createChart () {
                /* Chart code */
                // Themes begin
                am4core.useTheme(am4themes_animated);
                // Themes end

                // Create chart instance
                this.chart = am4core.create(this.$refs.reportReasonDistributionBarChart, am4charts.XYChart);

                this.chart.colors.list = [
                    am4core.color("#B1E5FD"),
                    am4core.color("#FFCDD1"),
                    am4core.color("#B1DFDB"),
                    am4core.color("#C3DFB1"),
                    am4core.color("#CDB1DF"),
                    am4core.color("#DFD4B1"),
                ]

                // Create axes
                let categoryAxis = this.chart.yAxes.push(new am4charts.CategoryAxis());
                categoryAxis.dataFields.category = "reason";
                categoryAxis.renderer.grid.template.location = 0;


                let valueAxis = this.chart.xAxes.push(new am4charts.ValueAxis());
                valueAxis.renderer.inside = true;
                valueAxis.renderer.labels.template.disabled = true;
                valueAxis.min = 0;

                this.createSeries("mpx1", "MPX 1");
                this.createSeries("mpx2", "MPX 2");
                this.createSeries("mpx3", "MPX 3");
                this.createSeries("spx1", "SPX 1");
                this.createSeries("spx2", "SPX 2");
                this.createSeries("unknown", "Unknown");

                // Legend
                this.chart.legend = new am4charts.Legend();

            },
            createSeries(field, name) {
            
                // Set up series
                let series = this.chart.series.push(new am4charts.ColumnSeries());
                series.name = name;
                series.dataFields.categoryY = "reason";
                series.dataFields.valueX = field;
                series.sequencedInterpolation = true;
                
                // Make it stacked
                series.stacked = true;
                
                // Configure columns
                series.columns.template.width = am4core.percent(60);
                series.columns.template.tooltipText = "[bold]{name}[/]\n[font-size:14px]{categoryY}: {valueX}";
                
                // Add label
                let labelBullet = series.bullets.push(new am4charts.LabelBullet());
                labelBullet.label.text = "{valueY}";
                labelBullet.locationY = 0.5;
                labelBullet.label.hideOversized = true;
                
                return series;
            }
        }
    }
</script>

<style scoped>
    
</style>